<template>
  <div data-view="daily-reports">
    <layout-logged-frame :title="$t('cpc_reports')" has-before>
      <template v-slot:header-actions>
        <v-btn
          color="primary"
          :disabled="!hasDailyReports"
          :loading="isDownloadingReport"
          @click="downloadReport"
        >
          <v-icon>arrow_downward</v-icon>
          {{ $t('download') }}
          <span> .csv</span>
        </v-btn>
      </template>

      <template v-slot:before>
        <NavigationTabs v-if="canSeeAdvancedReports" :tabs="navigationTabs"/>
      </template>

      <template v-slot:content>
        <div class="form-wrapper">
          <ReportFilters
            :is-skeleton-loading="isSkeletonLoading"
            @filter="onFilter"
            @clearFilters="onClearFilters"
          />

          <table-base-client-sort
            :columns="columns"
            :items="dailyReports"
            :is-loading="isLoading"
            :no-data-title="$t('no_reports')"
            :no-data-subtitle="$t('start_to_use_our_products')"
            has-custom-items-template
          >
            <template
              v-slot:item-cell="scope"
            >
              <template v-if="scope.cell.column.value === 'daily_commission'">
                {{ `${scope.cell.item.daily_commission} ${scope.cell.item.currency.symbol}` }}
              </template>

              <template v-else>
                {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
              </template>
            </template>
          </table-base-client-sort>
        </div>
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  import navigationTabs from '../../config/reports/navigationTabs';
  import NavigationTabs from '../../components/NavigationTabs'
  import ReportFilters from '../../components/forms/filters/Reports';
  import columns from '../../config/reports/columns';
  import {
    isObj,
    isArr,
    extractNestedProp,
    openUrlInNewWindow,
  } from '../../utils';

  export default {
    components: {
      NavigationTabs,
      ReportFilters,
    },
    data() {
      return {
        columns,
        navigationTabs,
        pagination: {
          totalItems: 0,
        },
        query: {},
        isLoading: false,
        isSkeletonLoading: true,
        isDownloadingReport: false,
      };
    },
    computed: {
      canSeeAdvancedReports() {
        return this.$ability.can('view', 'cpc-reports-advanced')
      },
      dailyReports() {
        return this.$store.getters['reports/daily'].items;
      },
      hasDailyReports() {
        const { dailyReports } = this;
        return isArr(dailyReports) && dailyReports.length > 0;
      },
    },
    methods: {
      getReports({ contract = -1, date_range = '' } = {}) {
        this.isLoading = true;
        const query = {
          contract,
          date_range,
        };

        return this.$store
          .dispatch('reports/getDaily', query)
          .then((res) => {
            this.query = query;
            this.pagination.totalItems = res.items.length;
            this.isLoading = false;

            this.isSkeletonLoading = false;

            return res;
          })
          .catch((err) => {
            this.isSkeletonLoading = false;

            this.isLoading = false;
            return err;
          });
      },
      getSearchQuery({ contract, dates }) {
        const query = {};

        query.contract = isObj(contract) ? contract.id : -1;
        query.date_range = dates;

        return query;
      },
      onFilter(filters) {
        this.query = {
          ...this.query,
          page: 1,
          ...this.getSearchQuery(filters)
        };

        this.getReports(this.query);
      },
      onClearFilters(filters) {
        this.onFilter(filters);
      },
      downloadReport() {
        const { contract, date_range } = this.query;
        const query = {
          contract,
          date_range,
        };

        this.isDownloadingReport = true;
        return this.$store
          .dispatch('reports/downloadDaily', query)
          .then((res) => {
            this.isDownloadingReport = false;
            return res;
          })
          .catch((err) => {
            this.isDownloadingReport = false;
            return err;
          });
      },
      openUrl(event, url) {
        event.preventDefault();
        event.stopPropagation();
        return openUrlInNewWindow(window.open(), url);
      },
      displayColumnValue(item, columnValue) {
        return extractNestedProp(item, columnValue);
      },
    },
  };
</script>
